<template>
  <form @submit.prevent="saveChargingSession">
    <!-- Fahrzeugauswahl (nur für Gastnutzer) -->
    <VehicleForm v-if="isGuest" :manufacturers="manufacturers" :vehicleData="vehicleData" ref="vehicleForm" />

    <!-- Pflichtfelder -->
    <div class="form-group">
      <label>
        <p>Datum*</p>
        <input type="date" v-model="form.date" required />
      </label>
    </div>

    <div class="form-group">
  <div v-if="!isGuest">
    <label class="toggle-label">
      <input
        type="radio"
        name="inputMode"
        :checked="useOdometer"
        @click="setInputMode(true)"
      />
      <span :class="{ active: useOdometer }">Kilometerstand</span>
    </label>
    <label class="toggle-label">
      <input
        type="radio"
        name="inputMode"
        :checked="!useOdometer"
        @click="setInputMode(false)"
      />
      <span :class="{ active: !useOdometer }">Gefahrene Kilometer</span>
    </label>
  </div>
  <div v-else>
    <p>Gefahrene Kilometer*</p>
  </div>
  <input
      type="number"
      v-model="distanceInput"
      required
      :placeholder="useOdometer && !isGuest ? 'Kilometerstand' : 'Gefahrene Kilometer' "
    />
</div>
<!--
<div class="form-group">
  <label>
    <p>{{ useOdometer && !isGuest ? 'Kilometerstand*' : 'Gefahrene Kilometer seit letzter Ladung*' }}</p>
    <input
      type="number"
      v-model="distanceInput"
      required
      :placeholder="useOdometer && !isGuest ? 'Kilometerstand' : 'Gefahrene Kilometer' "
    />
  </label>
</div>-->

    <div class="form-group">
      <label>
        <p>Lademenge* (kWh)</p>
        <input type="number" v-model="form.energy" required placeholder="Geladene kWh eingeben" />
      </label>
    </div>

    <div class="form-group">
      <label>
        <p>Kosten* (€)</p>
        <input type="number" v-model="form.cost" required placeholder="Kosten eingeben" />
      </label>
    </div>

    <!-- Umschaltfunktion (nur für eingeloggte Nutzer)
    <div class="form-group" v-if="!isGuest">
      <button type="button" @click="toggleInputMode" class="toggle-button">
        {{ useOdometer ? 'Wechsel zu gefahrenen Kilometern' : 'Wechsel zu Kilometerstand' }}
      </button>
    </div>-->

    <!-- Option zum Ausklappen weiterer Details -->
    <div class="form-group toggle-details">
        <button type="button" @click="toggleDetails" class="toggle-button">
          {{ showDetails ? 'Weniger Details' : 'Weitere Details' }}
        </button>
      </div>

      <!-- Zusätzliche Felder -->
      <div v-if="showDetails">
        <div class="form-group">
          <label>
            <p>SOC Start (%)</p>
            <input type="number" v-model="form.socStart" placeholder="SOC bei Start (%) eingeben" />
          </label>
        </div>
        <div class="form-group">
          <label>
            <p>SOC Ende (%)</p>
            <input type="number" v-model="form.socEnd" placeholder="SOC nach Ladevorgang (%) eingeben" />
          </label>
        </div>
        <div class="form-group">
          <label>
            <p>Reichweite Start (km)</p>
            <input type="number" v-model="form.rangeStart" placeholder="Reichweite bei Start eingeben" />
          </label>
        </div>
        <div class="form-group">
          <label>
            <p>Dauer Ladevorgang (min)</p>
            <input type="number" v-model="form.chargeDuration" placeholder="Dauer des Ladevorgangs eingeben" />
          </label>
        </div>
        <div class="form-group">
          <label>
            <p>Außentemperatur</p>
            <input type="text" v-model="form.chargeTemperature" placeholder="Außentemperatur beim Ladevorgang eingeben" />
          </label>
        </div>
        <div class="form-group">
          <label>
            <p>Verwendeter Ladedienst</p>
            <input type="text" v-model="form.chargeService" placeholder="Ladedienst eingeben (z. B. EnBW, Ionity)" />
          </label>
        </div>
      </div>

    <!-- Absenden -->
    <button class="submit-button" type="submit">Ladedaten speichern</button>
  </form>
</template>

<script>
import VehicleForm from './VehicleForm.vue'
import axios from 'axios'

const defaultForm = () => ({
  date: new Date().toISOString().split('T')[0],
  odometer: '',
  kmSinceLastCharge: '',
  distanceDriven: '',
  energy_kWh: '',
  cost: '',
  socStart: '',
  socEnd: '',
  rangeStart: '',
  chargeDuration: '',
  chargeTemperature: '',
  chargeService: ''
})

export default {
  components: { VehicleForm },
  props: {
    isGuest: {
      type: Boolean,
      default: false
    },
    manufacturers: {
      type: Array,
      required: true
    },
    vehicleData: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.userId = this.user?.id
    if (this.userId) {
      console.log('Benutzer authentifiziert:', this.userId)
    } else {
      console.error('Benutzer nicht authentifiziert.')
    }
    console.log('ChargingSessionForm.vue wurde gemountet', new Date().getTime())
  },
  created () {
    if (!this.$options._eventBound) {
      this.$options._eventBound = true
      console.log('Event-Binding initialisiert:', this._uid)
    }
  },
  data () {
    return {
      form: defaultForm(),
      userId: null,
      useOdometer: true, // Standardmäßig auf Kilometerstand
      showDetails: false // zeigt weitere Inputfelder
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser // Holt den aktuellen User aus Vuex
    },
    distanceInput: {
      get () {
        return this.isGuest || !this.useOdometer
          ? this.form.kmSinceLastCharge
          : this.form.odometer
      },
      set (value) {
        if (this.isGuest || !this.useOdometer) {
          this.form.kmSinceLastCharge = value
        } else {
          this.form.odometer = value
        }
      }
    }
  },
  methods: {
    toggleInputMode () {
      this.useOdometer = !this.useOdometer
    },
    toggleDetails () {
      this.showDetails = !this.showDetails
    },
    setInputMode (mode) {
      this.useOdometer = mode
      this.distanceInput = '' // Reset des Eingabefelds bei Moduswechsel
    },
    saveChargingSession (event) {
      console.log('saveChargingSession-Event wurde ausgelöst:', event)
      if (this._isSubmitting) {
        console.log('Doppeltes saveChargingSession Event erkannt, übersprungen:', new Date().getTime())
        return
      }
      this._isSubmitting = true
      console.log('saveChargingSession ausgelöst', new Date().getTime())
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault() // Unterdrücke Standardevents
      } else {
        console.error('Ungültiges Event empfangen:', event)
      }
      // console.log('saveChargingSession ausgelöst', new Date().getTime())
      if (this.isGuest && !this.$refs.vehicleForm.getSelectedVehicle().variant) {
        alert('Bitte Fahrzeugdaten ausfüllen!')
        return
      }
      if (!this.form.date || !this.form.energy || !this.form.cost || (!this.isGuest && !this.form.odometer) || (this.isGuest && !this.form.kmSinceLastCharge)) {
        alert('Bitte alle Pflichtfelder ausfüllen!')
        return
      }
      const data = {
        ...this.form,
        distanceDriven: parseFloat(this.isGuest ? this.form.kmSinceLastCharge : -100),
        vehicle: this.isGuest ? this.$refs.vehicleForm.getSelectedVehicle() : null,
        userId: this.userId,
        odometer: parseFloat(this.form.odometer ? this.form.odometer : -100)
      }
      console.log('Zu sendende Daten:', data)
      axios
        .post('/api/saveChargingSession.php', data)
        .then((response) => {
          console.log('Erfolgreich gespeichert:', response.data)
        })
        .catch((error) => {
          console.error('Fehler beim Speichern:', error.response.data)
        })
      console.log('Daten vor Emit:', data, new Date().getTime())
      this.$emit('submitDataToParent', data)
      console.log('Nach Emit in saveChargingSession')
      // this.resetForm()
    }
  }
}
</script>
